import {getCanvasSettings, DEFAULT_CANVAS_SETTINGS, CanvasSettings, useAppSelector} from '@dv5/domain'
import {useMemo} from "react"

export const useCanvasSettings = (canvasId: string): CanvasSettings => {
    const settings = useAppSelector(getCanvasSettings)
    return useMemo(() => ({...DEFAULT_CANVAS_SETTINGS, ...settings[canvasId]}), [canvasId, settings])
}